// extracted by mini-css-extract-plugin
module.exports = {"checkList":"check-list-module--check-list--3S-H9","checks":"check-list-module--checks--3V8f9"};